import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../src/assets/smartphone1.png'


const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 d-flex align-items-center justify-content-center text-start ps-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fs-3 p-5" }, "Empowering the growth your company deserves and inspiring the momentum your team needs.")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    style: {"height":"500px"}
  })
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}